import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Checkbox, Table } from 'rsuite'
import { getAbbreviatedState } from '../../../services/helper'

const { Column, HeaderCell, Cell, Pagination } = Table

export const TableCell = ({ rowData, dataKey, onClick, contacts = [], ...props }) => {
    if (dataKey === 'state' && rowData[dataKey]) {
        rowData[dataKey] = getAbbreviatedState('', rowData[dataKey])
    }

    if (dataKey === 'spend') {
        return (
            <Cell {...props} className="table-link unmatched-vendors-table-cell text-black" id={rowData.id} title={rowData?.supplierDetail[dataKey]}>
                {rowData?.supplierDetail[dataKey]}
            </Cell>
        )
    }

    if (dataKey === 'email' || dataKey === 'phone') {
        let value = ''
        if (dataKey === 'email') {
            value = (rowData?.[dataKey] && /^\d+$/.test(rowData?.[dataKey])) ? contacts?.find(data => data?.id === parseInt(rowData?.[dataKey]))?.[dataKey] : (rowData?.[dataKey] || '')
        }
        if (dataKey === 'phone') {
            value = (rowData?.[dataKey] && /^\d+$/.test(rowData?.[dataKey])) && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(rowData?.[dataKey]) ? contacts?.find(data => data?.id === parseInt(rowData?.[dataKey]))?.[dataKey] : (rowData?.[dataKey] || '')
        }
        return (
            <Cell {...props} className="table-link unmatched-vendors-table-cell text-black" id={rowData.id} title={value}>
                {value}
            </Cell>
        )
    }

    return (
        <Cell {...props} className="table-link unmatched-vendors-table-cell text-black" id={rowData.id} title={rowData?.[dataKey]}>
            {rowData[dataKey]}
        </Cell>
    )
}

const CheckCell = ({ rowData, onChange, checkedKeys, dataKey, ...props }) => (
    <Cell {...props} style={{ padding: 0, display: 'flex', alignItems: 'center', margin: 0 }}>
        <Checkbox
            value={rowData[dataKey]}
            onChange={onChange}
            checked={checkedKeys.some(item => item === rowData[dataKey])}
        />
    </Cell>
)

const UnmatchedVendors = ({
    tabledata,
    total,
    unmatchedVendorsColumns,
    listId,
    onGetTableData,
    setShowCreateMasterModal,
    currentTab,
    searchValue,
    handleCheckAll,
    handleCheck,
    checkedKeys,
    checked,
    indeterminate,
    unmatchedVendorPage,
    setUnmatchedVendorPage,
    contactsData = [],
    onSetRowLimit,
    setSelectedRows
}) => {
    const dispatch = useDispatch()
    const [limit, setLimit] = useState(10)
    const [tableData, setTableData] = useState([])
    const [totalData, setTotalData] = useState(0)
    const [sortColumn, setSortColumn] = useState('suppliername')
    const [sortType, setSortType] = useState('asc')
    const [contacts, setContacts] = useState([])
    useEffect(() => {
        onGetTableData(1, 10, 'unmatched', "", "suppliername", "asc")
    }, [])

    useEffect(() => {
        if (!tabledata || tabledata?.length === 0) {
            setTableData([])
            setTotalData(0)
            return
        }
        setTableData(tabledata)
        setTotalData(total)
    }, [tabledata])

    useEffect(() => {
        if (contactsData && contactsData?.length > 0) {
            setContacts(contactsData)
        } else {
            setContacts([])
        }
    }, [contactsData])

    useEffect(() => {
        const selected = tableData.filter(row => checkedKeys.includes(row.id))
        setSelectedRows(selected)
    }, [checkedKeys, tableData])

    const handleChangeLimit = dataKey => {
        setUnmatchedVendorPage(1)
        onSetRowLimit(dataKey)
        setLimit(dataKey)
        onGetTableData(1, dataKey, 'unmatched', searchValue, "suppliername", "asc")
    }

    const handleChangePage = (event) => {
        setUnmatchedVendorPage(event)
        onGetTableData(event, limit, 'unmatched', searchValue, sortColumn, sortType)
    }

    const handleSortColumn = (sortColumn, sortType) => {
        setSortColumn(sortColumn)
        setSortType(sortType)
        onGetTableData(unmatchedVendorPage, limit, currentTab, searchValue, sortColumn, sortType)
    }

    const headerElements = unmatchedVendorsColumns.map((col, index) => {
        if (col.name === 'partnerSupplierId' || col.name === 'accountNumber') {
            return null
        }
        return (
            <Column
                resizable
                sortable
                key={col.name}
            >
                <HeaderCell className='fw-bold text-black'>{col.label}</HeaderCell>
                <TableCell className='text-black' dataKey={col.name} contacts={contacts} />
            </Column>
        )
    })

    return (
        <>
            <div className={`border border-2 border-top-0`}>
                <Table
                    virtualized={true}
                    autoHeight
                    affixHeader={true}
                    data={tableData}
                    id='unmatched-vendors-table'
                    className='unmatched-vendors-table'
                    sortColumn={sortColumn}
                    sortType={sortType}
                    onSortColumn={handleSortColumn}
                >
                    <Column width={50} align="center" >
                        <HeaderCell style={{ padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Checkbox
                                checked={checked}
                                indeterminate={indeterminate}
                                onChange={handleCheckAll}
                            />
                        </HeaderCell>
                        <CheckCell dataKey="id" checkedKeys={checkedKeys} onChange={handleCheck} />
                    </Column>
                    {headerElements}
                </Table>
                <div className="unmatched-vendor-table-pagination">
                    <Pagination
                        prev
                        next
                        first={true}
                        last={true}
                        maxButtons={5}
                        activePage={unmatchedVendorPage}
                        showInfo
                        layout={['limit', '|', 'pager']}
                        displayLength={limit}
                        lengthMenu={[
                            { label: '10', value: 10 },
                            { label: '20', value: 20 },
                            { label: '30', value: 30 },
                            { label: '50', value: 50 },
                            { label: '100', value: 100 },
                        ]}
                        total={totalData}
                        onChangeLength={handleChangeLimit}
                        onChangePage={(event) => { handleChangePage(event) }}
                    />
                </div>
            </div>
        </>
    )
}

export default UnmatchedVendors
